import axios from "axios";
const queryString = require("query-string");

// import { authApi } from "@api";
import { store, logout, refreshToken, openToast } from "@redux";
import { ADMINS_SITE } from "@configs";
import { IRefreshTokenRes } from "@interfaces";

const axiosPlainClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL_PLAIN,

    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "client-id": "rewarding-admin-site",
    },

    paramsSerializer: (params) => queryString.stringify(params),
});

axiosPlainClient.interceptors.request.use((config) => {
    // const token = await getFirebaseToken();
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }van
    const token = store.getState().auth.auth?.accessToken;
    config.headers["access-token"] = token;
    config.headers["client-id"] = ADMINS_SITE;

    return config;
});

axiosPlainClient.interceptors.response.use(
    (response) => {
        if (response && response.data) {
            return response;
        }
        return response;
    },
    async (error: any) => {
        // Handle errors
        if (error.response && error.response.status === 401) {
            //refreshToken
            const refreshTk = store.getState().auth.auth?.refreshToken?._id;
            if (refreshTk) {
                const refreshTokenBody = { refreshToken: refreshTk };
                try {
                    const res = await axios.post(
                        process.env.REACT_APP_API_URL_PLAIN + "/auth/login-refresh-token",
                        refreshTokenBody,
                        {
                            headers: {
                                "client-id": ADMINS_SITE,
                            },
                        }
                    );
                    if (res.status === 200) {
                        store.dispatch(refreshToken(res.data as IRefreshTokenRes));
                        const originalRequest = error.config;
                        const newToken = res.data.accessToken;
                        originalRequest.headers["access-token"] = newToken;
                        return Promise.resolve(axiosPlainClient(originalRequest));
                    } else {
                        store.dispatch(
                            openToast({
                                message: "You need to login again",
                                type: "warning",
                                autoHideDuration: 2000,
                            })
                        );
                        store.dispatch(logout());
                    }
                } catch {
                    store.dispatch(
                        openToast({
                            message: "You need to login again",
                            type: "warning",
                            autoHideDuration: 2000,
                        })
                    );
                    store.dispatch(logout());
                }
            } else {
                store.dispatch(
                    openToast({
                        message: "You need to login again ",
                        type: "warning",
                        autoHideDuration: 2000,
                    })
                );
                store.dispatch(logout());
            }
        } else if (error.response && error.response.status === 403) {
            store.dispatch(logout());
        }
        throw error;
    }
);

export default axiosPlainClient;
